import React from "react";
import Spinner from "../components/loaders/Spinner";
import loadable from "../utils/loadable";

// Dashboard
export const Dashboard = loadable(() => import("./Dashboard"), {
  fallback: <Spinner />
});

// calculator
export const GrowthCalculater = loadable(() => import("./GrowthCalculater"), {
  fallback: <Spinner />
});

// Kyc
export const Kyc = loadable(() => import("./Kyc"), {
  fallback: <Spinner />
});

// Withdraw
export const Withdraw = loadable(() => import("./Withdraw"), {
  fallback: <Spinner />
});

// Report
export const Report = loadable(() => import("./Report"), {
  fallback: <Spinner />
});

// PurchaseNodes
export const PurchaseNodes = loadable(() => import("./PurchaseNodes"), {
  fallback: <Spinner />
});

// Login
export const Login = loadable(() => import("./Login"), {
  fallback: <Spinner />
});

// RegisterPage
export const RegisterPage = loadable(() => import("./Register/RegisterPage"), {
  fallback: <Spinner />
});

// ForgotPassword
export const ForgotPassword = loadable(() => import("./ForgotPassword"), {
  fallback: <Spinner />
});

// Purchase
export const Purchase = loadable(() => import("./Purchase"), {
  fallback: <Spinner />
});

// Purchase
export const OnlinePurchase = loadable(
  () => import("./PurchaseNodes/OnlinePurchase"),
  {
    fallback: <Spinner />
  }
);

// AffiliateList
export const AffiliateList = loadable(() => import("./Affiliate"), {
  fallback: <Spinner />
});

// Franchise
export const Franchise = loadable(() => import("./Franchise/Franchise"), {
  fallback: <Spinner />
});
// Payout
export const Payout = loadable(() => import("./Payout"), {
  fallback: <Spinner />
});

// Commission
export const Commission = loadable(() => import("./Commission"), {
  fallback: <Spinner />
});

// CommissionTable
export const CommissionTable = loadable(
  () => import("./Commission/CommissionTable"),
  {
    fallback: <Spinner />
  }
);

// About Page
export const About = loadable(() => import("./About"), {
  fallback: <Spinner />
});
// Privacy Page
export const Privacy = loadable(() => import("./Privacy"), {
  fallback: <Spinner />
});
// KycInfo Page
export const KycInfo = loadable(() => import("./KycInfo"), {
  fallback: <Spinner />
});
// Terms Page
export const Terms = loadable(() => import("./Terms"), {
  fallback: <Spinner />
});
// Cancellation Page
export const Cancellation = loadable(() => import("./Cancellation"), {
  fallback: <Spinner />
});
// Shipping Page
export const Shipping = loadable(() => import("./Shipping"), {
  fallback: <Spinner />
});

// Contact Page
export const Contact = loadable(() => import("./Contact"), {
  fallback: <Spinner />
});

// Coin Earn Page
export const CoinEarn = loadable(() => import("./CoinEarn"), {
  fallback: <Spinner />
});

// Fractions Earn Page
export const FractionsEarn = loadable(() => import("./FractionsEarn"), {
  fallback: <Spinner />
});

// Fractions Page
export const Fractions = loadable(() => import("./Fractions"), {
  fallback: <Spinner />
});

// NotFound
export const NotFound = loadable(() => import("./NotFound"), {
  fallback: <Spinner />
});

// Maintenance
export const Maintenance = loadable(() => import("./Maintenance"), {
  fallback: <Spinner />
});

// Rewards
export const Rewards = loadable(() => import("./Rewards"), {
  fallback: <Spinner />
});

// FlagCommunication
export const FlagCommunication = loadable(() => import("./FlagCommunication"), {
  fallback: <Spinner />
});

// FlagCommunication
export const FlagReport = loadable(() => import("./FlagReport"), {
  fallback: <Spinner />
});

// FlagCommunication
export const FlagReportTable = loadable(
  () => import("./FlagReport/child/MainTable"),
  {
    fallback: <Spinner />
  }
);

// SalesReport
export const SalesReport = loadable(() => import("./SalesReport"), {
  fallback: <Spinner />
});

// EligibleReferralTable
export const EligibleReferralTable = loadable(
  () => import("./SalesReport/EligibleReferralTable"),
  {
    fallback: <Spinner />
  }
);

// RemainingReferralTable
export const RemainingReferralTable = loadable(
  () => import("./SalesReport/RemainingReferralTable"),
  {
    fallback: <Spinner />
  }
);

export const Delegates = loadable(() => import("./Delegates/Delegates"), {
  fallback: <Spinner />
});

export const Community = loadable(() => import("./Community"), {
  fallback: <Spinner />
});

export const TeamAndPartners = loadable(() => import("./TeamAndPartners"), {
  fallback: <Spinner />
});

export const ProposalList = loadable(() => import("./DaoPages/ProposalList"), {
  fallback: <Spinner />
});

export const ProposalForm = loadable(() => import("./DaoPages/ProposalForm"), {
  fallback: <Spinner />
});

export const ProposalDetail = loadable(
  () => import("./DaoPages/ProposalDetail"),
  {
    fallback: <Spinner />
  }
);

export const DeligatesDetails = loadable(
  () => import("./DaoPages/DeligatesDetails"),
  {
    fallback: <Spinner />
  }
);

export const DaoHome = loadable(() => import("./DaoPages/Home"), {
  fallback: <Spinner />
});

export const DraftList = loadable(() => import("./DaoPages/DraftList"), {
  fallback: <Spinner />
});

export const ScannerDetails = loadable(
  () => import("./Scanner/ScannerDetails"),
  {
    fallback: <Spinner />
  }
);

export const TwitterOauth = loadable(() => import("./TwitterOauth"), {
  fallback: <Spinner />
});
export const ReportTwo = loadable(() => import("./Report/ReportTwo"), {
  fallback: <Spinner />
});

export const ReportOne = loadable(() => import("./Report/ReportOne"), {
  fallback: <Spinner />
});

export const Scanner = loadable(() => import("./Scanner"), {
  fallback: <Spinner />
});

export const ClubReport = loadable(() => import("./ClubReport"), {
  fallback: <Spinner />
});
